"use strict";exports.p=e=>{const t=new Map(e.map(e=>[e.name,e.value]));return Object.fromEntries(t)};